/**
 * Created by chao.z on 18/3/16.
 */
import { CHANGE_HEIGHT } from '../actions/nutrition';

const initState = {};

export default (state = initState, action) => {
  switch (action.type) {
    case CHANGE_HEIGHT: {
      return Object.assign({}, state, action.obj);
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/nutrition.js